import * as Sentry from "@sentry/react";
import { Middleware } from "redux";

import { FeatureFlagsActionType } from "../../Externals/FeatureFlags/Store/FeatureFlagsActions";
import { UnitActionType } from "../../../Controls/FormParts/Unit/Store/unitActions";

import { CandyDispatch, CandyThunkAction } from "./CandyReduxTypes";
import { FullFormAction } from "./FullFormAction";

const actionTypeBlacklist: string[] = [FeatureFlagsActionType.LoadInitialFeatureFlags, UnitActionType.InitUnitInfo];

export function sentryBreadcrumbsMiddleware(hub: Sentry.Hub): Middleware {
    const result =
        () =>
        (next: CandyDispatch): CandyDispatch =>
        <R>(action: FullFormAction | CandyThunkAction<R>): R | void => {
            if (typeof action !== "function") {
                try {
                    if (actionTypeBlacklist.includes(action.type as string)) {
                        return next(action);
                    }

                    const actionPayloadToLog =
                        // @ts-ignore
                        action["payload"] === undefined
                            ? undefined
                            : // @ts-ignore
                              // eslint-disable-next-line @typescript-eslint/no-unsafe-argument
                              Object.keys(action["payload"]).length > 10
                              ? "[LargePayload]"
                              : // @ts-ignore
                                action["payload"];

                    hub.addBreadcrumb({
                        level: "log",
                        data: { type: action.type, payload: actionPayloadToLog },
                        category: "ReduxAction",
                    });
                } catch (e) {
                    hub.addBreadcrumb({
                        level: "error",
                        message: `Redux action breadcrumb build failed: ${
                            e instanceof Error ? e?.message : "unknown reason"
                        }`,
                        category: "ReduxAction",
                    });
                }
            }
            // @ts-ignore
            return next(action);
        };
    // eslint-disable-next-line @typescript-eslint/no-unsafe-return,@typescript-eslint/no-explicit-any
    return result as any;
}
